export enum FancyRowStyles {
  Line = 'Line',
}
